import * as React from "react";

function DescriptiveIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="4"
      viewBox="0 0 20 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="3"
        rx="0.5"
        fill="white"
        stroke={props.fill}
      />
    </svg>
  );
}

export default DescriptiveIcon;
